import { render, staticRenderFns } from "./BookingPaymentStatus.vue?vue&type=template&id=d506eb82&scoped=true"
import script from "./BookingPaymentStatus.vue?vue&type=script&lang=ts"
export * from "./BookingPaymentStatus.vue?vue&type=script&lang=ts"
import style0 from "./BookingPaymentStatus.vue?vue&type=style&index=0&id=d506eb82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d506eb82",
  null
  
)

export default component.exports